"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../services");
var _constants = require("../utils/constants");
var _uiSelectors = require("../store/ui/uiSelectors");
var _useLocalTheme = _interopRequireDefault(require("../hooks/useLocalTheme"));
var _useAppSelector = require("../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepperContainer = _styledComponents.default.div`
  width: 100%;
`;
const STEPS = [_constants.PAGES.QUESTIONNAIRE, _constants.PAGES.RECOMMENDATION];
const Stepper = () => {
  const showMainStepper = (0, _useLocalTheme.default)('showMainStepper', false);
  if (!showMainStepper) return null;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const [currentStep, setStep] = (0, _react.useState)(1);
  (0, _react.useEffect)(() => {
    const pageStep = STEPS.findIndex(s => s === currentPage);
    setStep(pageStep + 1);
  }, [currentPage]);
  const steps = STEPS.map(s => ({
    title: _services.locale.localeString(`MainStepper.${s.toLowerCase()}`)
  }));
  if (currentStep === 0) return null;
  return /*#__PURE__*/_react.default.createElement(StepperContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.HorizontalStepper, {
    currentStep: currentStep,
    steps: steps,
    id: "main-stepper"
  }));
};
var _default = Stepper;
exports.default = _default;